import React, { useEffect } from "react";
import { connect } from "react-redux";
import "./index.css";
import "../index.css";
import IndicatorTimeline from "../IndicatorTimeline";

const EightType = (props) => {
  const { data, index, activePoint, setActivePoint } = props;
  useEffect(() => {
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    data && (
      <>
        <IndicatorTimeline
          setActivePoint={setActivePoint}
          activePoint={activePoint}
          index={index}
        />
        <div className="container_card">
          <div className="date_container_eight_type">
            <h1>{data.year}</h1>
            {/* <div dangerouslySetInnerHTML={{ __html: data.subtitle }} /> */}
            <h3>{data.subtitle} </h3>
            <div dangerouslySetInnerHTML={{ __html: data.body }} />
          </div>
        </div>
      </>
    )
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(EightType);
